import { TypeDefinition } from "../generic";

export class Placements {
    public static ExpertPanel: TypeDefinition = { id: 1, name: "Expert panel" };
    public static FullLength: TypeDefinition = { id: 2, name: "Full length" };
    public static RapidFire: TypeDefinition = { id: 3, name: "Rapid fire" };
    public static _2D: TypeDefinition = { id: 4, name: "2D" };
    public static _3D: TypeDefinition = { id: 5, name: "3D" };
    public static OnDemand: TypeDefinition = { id: 6, name: "On Demand" };
    public static Live: TypeDefinition = { id: 7, name: "Live" };

    public static Values: TypeDefinition[] = [
        Placements.FullLength,
        Placements.RapidFire,
        Placements.ExpertPanel,
        Placements._2D,
        Placements._3D,
        Placements.OnDemand,
        Placements.Live,
    ];
}



// WEBPACK FOOTER //
// ./src/models/abstract/Placements.ts